// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__qs1pn","footer":"ModalError_footer__8Cj_S"};